import { Stage, Layer, Rect, Line } from 'react-konva';
import Square from '../CardElements/Square';
import Ellipsis from '../CardElements/Ellipsis';
import TextComponent from '../CardElements/Text';
import ImageComponent from '../CardElements/ImageComponent';
import CanvasSide from '../Functionality/CanvasSide';
/**
 * @Email : sgarcia@ibl.mx
 * @Author: Susana Garcia Rodriguez
 * @jobTittle: Frontend
 */
const CanvasFrontAndBack = ({
    currentStage,
    stageProperties,
    stageWidth,
    stageHeight,
    selectedShape,
    handleShapeClick,
    setStageProperties,
    setShapeHeight,
    setShapeWidth,
    setShapeRadius,
    setFontSize,
    cardBackgroundColor,
    stageFront,
    stageBack,
    setShowResources,
    updateForm,
    setSelectedShape,
    fontSize,
    setShapeHorizontal,
    setShapeVertical,
    disabled,
}) => {
    const { handleStageClick, handleDrop, handleDragMove } = CanvasSide({
        currentStage,
        stageProperties,
        stageWidth,
        stageHeight,
        selectedShape,
        handleShapeClick,
        setStageProperties,
        setShapeHeight,
        setShapeWidth,
        setShapeRadius,
        setFontSize,
        cardBackgroundColor,
        stageFront,
        stageBack,
        setShowResources,
        updateForm,
        setSelectedShape,
        fontSize,
        setShapeHorizontal,
        setShapeVertical,
    });
    // Without a selected shape the elements are neither draggable nor resizable
    const selectedShapeId = disabled ? undefined : selectedShape?.id;
    const onShapeClick = (shape, index) => {
        if (!disabled) handleShapeClick(shape, index);
    };

    return (
        <div
            className='d-flex justify-content-center'
            onDrop={disabled ? undefined : handleDrop}
            onDragOver={(e) => e.preventDefault()}
        >
            <Stage
                ref={currentStage === 1 ? stageFront : stageBack}
                width={stageWidth}
                height={stageHeight}
                onClick={disabled ? undefined : handleStageClick}
            >
                <Layer>
                    <Rect id='background' width={stageWidth} height={stageHeight} fill={cardBackgroundColor} />
                    {stageProperties[currentStage].orientation === 'vertical' ? (
                        <>
                            <Line key='0980' points={[152, 0, 152, 500]} stroke='#000' strokeWidth={1} opacity={0.05} />
                            <Line key='0981' points={[0, 230, 505, 230]} stroke='#000' strokeWidth={1} opacity={0.05} />
                        </>
                    ) : (
                        <>
                            <Line key='0980' points={[240, 0, 240, 805]} stroke='#000' strokeWidth={1} opacity={0.05} />
                            <Line key='0981' points={[0, 145, 825, 145]} stroke='#000' strokeWidth={1} opacity={0.05} />
                        </>
                    )}

                    {stageProperties[currentStage].combinedObject.map((shape, index) => {
                        if (shape.property === 'squares' || shape.property === 'lines') {
                            return (
                                <Square
                                    key={shape.id}
                                    square={shape}
                                    index={index}
                                    currentStage={currentStage}
                                    properties={stageProperties}
                                    selectedShapeId={selectedShapeId}
                                    handleDragMove={handleDragMove}
                                    handleShapeClick={() => onShapeClick(shape, index)}
                                    setStageProperties={setStageProperties}
                                    setShapeHeight={setShapeHeight}
                                    setShapeWidth={setShapeWidth}
                                />
                            );
                        } else if (shape.property === 'ellipsis') {
                            return (
                                <Ellipsis
                                    key={shape.id}
                                    ellipsis={shape}
                                    index={index}
                                    currentStage={currentStage}
                                    properties={stageProperties}
                                    selectedShapeId={selectedShapeId}
                                    handleDragMove={handleDragMove}
                                    handleShapeClick={() => onShapeClick(shape, index)}
                                    setStageProperties={setStageProperties}
                                    setShapeRadius={setShapeRadius}
                                    setShapeHeight={setShapeHeight}
                                    setShapeWidth={setShapeWidth}
                                />
                            );
                        } else if (shape.property === 'texts') {
                            return (
                                <TextComponent
                                    key={shape.id}
                                    text={shape}
                                    index={index}
                                    selectedShapeId={selectedShapeId}
                                    properties={stageProperties}
                                    handleDragMove={handleDragMove}
                                    handleShapeClick={() => onShapeClick(shape, index)}
                                    currentStage={currentStage}
                                    setStageProperties={setStageProperties}
                                    setShapeHeight={setShapeHeight}
                                    setShapeWidth={setShapeWidth}
                                    setFontSize={setFontSize}
                                    disabled={disabled}
                                />
                            );
                        } else if (shape.property === 'resources') {
                            return (
                                <ImageComponent
                                    key={shape.id}
                                    image={shape}
                                    index={index}
                                    currentStage={currentStage}
                                    properties={stageProperties}
                                    selectedShapeId={selectedShapeId}
                                    handleDragMove={handleDragMove}
                                    handleShapeClick={() => onShapeClick(shape, index)}
                                    setStageProperties={setStageProperties}
                                    setShapeHeight={setShapeHeight}
                                    setShapeWidth={setShapeWidth}
                                />
                            );
                        }
                        return null;
                    })}
                </Layer>
            </Stage>
        </div>
    );
};

export default CanvasFrontAndBack;
